import styled from 'styled-components';

import {createBox} from '@famly/mf_layout_box';

export const PageContainer = createBox({padding: {base: '32px 16px 48px', tabletPortrait: '40px 40px 120px'}});

export const StyledPageContainer = styled(PageContainer)`
    box-sizing: border-box;
    height: 100vh; // Fallback for browsers that don't support svh unit
    height: 100svh;
    max-height: 100vh; // Fallback for browsers that don't support svh unit
    max-height: 100svh;
    display: flex;
    flex-direction: column;
    padding-bottom: 74px !important; // Override to ensure GroupGrid is taking all available space
`;

export const HeaderLogoContainer = styled(createBox({}))`
    * {
        max-height: 32px;
    }
    svg,
    img {
        width: auto;
    }
`;
